var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCommercial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 91,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-11.9%",
    y: "-9.6%",
    width: "123.8%",
    height: "119.2%",
    filterUnits: "objectBoundingBox",
    id: "icon-commercial_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0",
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0",
    "in": "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-commercial_svg__a)",
    transform: "translate(-56 -66)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150 145.362c0 2.562-20.149 4.638-45 4.638-24.854 0-45-2.076-45-4.638 0-2.561 20.146-4.637 45-4.637 24.851 0 45 2.076 45 4.637",
    fill: "#10C98F",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.875 145.772h45.75V73a2.25 2.25 0 00-2.25-2.25h-41.25a2.25 2.25 0 00-2.25 2.25v72.772z",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3F1E3",
    d: "M117.375 89.71l18 9.276v46.376h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.782 88.927l17.264 8.888a3.276 3.276 0 011.756 2.92M132.312 96.922V87.95M89.512 145.71h-1.255",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.833 85.09h-4.432c-.88 0-1.587-.732-1.587-1.631v-4.57c0-.901.708-1.634 1.587-1.634h4.432c.874 0 1.587.733 1.587 1.635v4.569c0 .899-.713 1.63-1.587 1.63z",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#C3F1E3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.836 98.794h-4.438c-.873 0-1.586-.73-1.586-1.63v-4.57c0-.901.713-1.63 1.586-1.63h4.438c.873 0 1.587.729 1.587 1.63v4.57c0 .9-.714 1.63-1.587 1.63z",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.836 112.498h-4.438c-.873 0-1.586-.73-1.586-1.63v-4.57c0-.902.713-1.631 1.586-1.631h4.438c.873 0 1.587.73 1.587 1.631v4.57c0 .9-.714 1.63-1.587 1.63z",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#C3F1E3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.836 126.202h-4.438c-.873 0-1.586-.73-1.586-1.63v-4.57c0-.901.713-1.631 1.586-1.631h4.438c.873 0 1.587.73 1.587 1.631v4.57c0 .9-.714 1.63-1.587 1.63z",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.836 139.906h-4.438c-.873 0-1.586-.73-1.586-1.63v-4.57c0-.901.713-1.63 1.586-1.63h4.438c.873 0 1.587.729 1.587 1.63v4.57c0 .9-.714 1.63-1.587 1.63z",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#C3F1E3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.523 85.09H78.09c-.879 0-1.586-.732-1.586-1.631v-4.57c0-.901.707-1.634 1.586-1.634h4.433c.874 0 1.586.733 1.586 1.635v4.569c0 .899-.712 1.63-1.586 1.63z",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.528 98.794h-4.44c-.872 0-1.584-.73-1.584-1.63v-4.57c0-.901.712-1.63 1.585-1.63h4.439c.872 0 1.586.729 1.586 1.63v4.57c0 .9-.714 1.63-1.586 1.63z",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#C3F1E3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.528 112.498h-4.44c-.872 0-1.584-.73-1.584-1.63v-4.57c0-.902.712-1.631 1.585-1.631h4.439c.872 0 1.586.73 1.586 1.631v4.57c0 .9-.714 1.63-1.586 1.63z",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.528 126.202h-4.44c-.872 0-1.584-.73-1.584-1.63v-4.57c0-.901.712-1.631 1.585-1.631h4.439c.872 0 1.586.73 1.586 1.631v4.57c0 .9-.714 1.63-1.586 1.63z",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#C3F1E3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.528 139.906h-4.44c-.872 0-1.584-.73-1.584-1.63v-4.57c0-.901.712-1.63 1.585-1.63h4.439c.872 0 1.586.729 1.586 1.63v4.57c0 .9-.714 1.63-1.586 1.63z",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.146 98.794h-4.44c-.872 0-1.584-.73-1.584-1.63v-4.57c0-.901.712-1.63 1.585-1.63h4.439c.872 0 1.586.729 1.586 1.63v4.57c0 .9-.714 1.63-1.586 1.63z",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#C3F1E3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.146 112.498h-4.44c-.872 0-1.584-.73-1.584-1.63v-4.57c0-.902.712-1.631 1.585-1.631h4.439c.872 0 1.586.73 1.586 1.631v4.57c0 .9-.714 1.63-1.586 1.63z",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.146 126.202h-4.44c-.872 0-1.584-.73-1.584-1.63v-4.57c0-.901.712-1.631 1.585-1.631h4.439c.872 0 1.586.73 1.586 1.631v4.57c0 .9-.714 1.63-1.586 1.63z",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#C3F1E3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.146 139.906h-4.44c-.872 0-1.584-.73-1.584-1.63v-4.57c0-.901.712-1.63 1.585-1.63h4.439c.872 0 1.586.729 1.586 1.63v4.57c0 .9-.714 1.63-1.586 1.63zM109.146 85.09h-4.44c-.872 0-1.584-.732-1.584-1.631v-4.57c0-.901.712-1.634 1.585-1.634h4.439c.872 0 1.586.733 1.586 1.635v4.569c0 .899-.714 1.63-1.586 1.63zM128.35 108.672h-4.436c-.877 0-1.586-.73-1.586-1.63v-4.572c0-.9.709-1.632 1.586-1.632h4.437c.875 0 1.585.733 1.585 1.632v4.573c0 .899-.71 1.63-1.585 1.63z",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.35 122.052h-4.436c-.877 0-1.586-.73-1.586-1.63v-4.57c0-.9.709-1.632 1.586-1.632h4.437c.875 0 1.585.731 1.585 1.633v4.568c0 .9-.71 1.63-1.585 1.63z",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.35 135.42h-4.436c-.877 0-1.586-.73-1.586-1.63v-4.569c0-.901.709-1.633 1.586-1.633h4.437c.875 0 1.585.732 1.585 1.633v4.569c0 .9-.71 1.63-1.585 1.63zM130.217 140.36h-7.746M135.808 145.46v-44.726M135.808 145.71h-22.69",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
export default SvgIconCommercial;